/*
  El formulario COD lo pinta la app EasySell con colores fijados por JS
  (style="background:... !important" en el propio elemento), así que el CSS
  del tema no puede ganarle por especificidad. Este script reaplica los
  colores de marca sobre esos mismos elementos cada vez que aparecen o
  cambian, sin tocar la lógica ni la estructura del formulario.

  Importante: como observamos cambios en el atributo "style" y a la vez lo
  modificamos, el observer se desconecta antes de tocar estilos y se
  reconecta después — si no, se dispara a sí mismo en bucle infinito.
*/
(function () {
  var GOLD_BG = 'linear-gradient(180deg,#D9BA76,#C9A24B)';
  var GOLD_SOLID = '#C9A24B';
  var INK = '#0D0D0D';
  var MARK = 'data-aa-styled';

  function styleTrigger(el) {
    if (el.getAttribute(MARK) === '1') return;
    el.style.setProperty('background', GOLD_BG, 'important');
    el.style.setProperty('background-color', GOLD_SOLID, 'important');
    el.style.setProperty('color', INK, 'important');
    el.style.setProperty('border-width', '0px', 'important');
    el.style.setProperty('border-radius', '999px', 'important');
    el.style.setProperty('min-height', '50px', 'important');
    el.querySelectorAll('*').forEach(function (child) {
      child.style.setProperty('color', INK, 'important');
    });
    el.setAttribute(MARK, '1');
  }

  function styleSubmit(el) {
    if (el.getAttribute(MARK) === '1') return;
    el.style.setProperty('background', GOLD_BG, 'important');
    el.style.setProperty('background-color', GOLD_SOLID, 'important');
    el.style.setProperty('color', INK, 'important');
    el.style.setProperty('border-width', '0px', 'important');
    el.style.setProperty('border-radius', '999px', 'important');
    el.style.setProperty('min-height', '50px', 'important');
    el.setAttribute(MARK, '1');
  }

  function apply(root) {
    if (!root) return;
    if (root.nodeType === 1) {
      if (root.classList && root.classList.contains('es-popup-button')) styleTrigger(root);
      if (root.id === 'es-form-button' || (root.classList && root.classList.contains('es-cta-btn'))) styleSubmit(root);
    }
    if (root.querySelectorAll) {
      root.querySelectorAll('.es-popup-button').forEach(styleTrigger);
      root.querySelectorAll('#es-form-button, .es-button.es-cta-btn').forEach(styleSubmit);
    }
  }

  function scan() {
    observer.disconnect();
    apply(document);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['style'], childList: true, subtree: true });
  }

  var observer = new MutationObserver(function (mutations) {
    var relevant = false;
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === 'attributes' && m.target.nodeType === 1 && m.target.getAttribute(MARK) !== '1' &&
          ((m.target.classList && (m.target.classList.contains('es-popup-button') || m.target.classList.contains('es-cta-btn'))) || m.target.id === 'es-form-button')) {
        relevant = true;
      }
      if (m.type === 'childList' && m.addedNodes.length) {
        for (var j = 0; j < m.addedNodes.length; j++) {
          if (m.addedNodes[j].nodeType === 1) { relevant = true; break; }
        }
      }
      if (relevant) break;
    }
    if (relevant) scan();
  });

  scan();
  [200, 600, 1200, 2500].forEach(function (ms) { setTimeout(scan, ms); });
})();
